// extracted by mini-css-extract-plugin
export default {"root":"LanguageComplianceTableExpandRow_root__mTtjj"};